import { lifecycle } from 'recompose';
import { path } from 'ramda';

import { twttr } from 'app/analytics/trackers/twttr';

const withTwitterConversionAnalytics = lifecycle({
  componentDidMount() {
    twttr(path(['etp', 'config', 'analytics', 'twitterConversionKey'], window));
  },
});

export default withTwitterConversionAnalytics;
